
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bumble-better",
      function () {
        return require("private-next-pages/bumble-better.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bumble-better"])
      });
    }
  